import React from 'react';
import { hot } from 'react-hot-loader';
import { default as View } from './View';

export const Error = hot(module)((props) => {
    return <View {...props} />;
});
